const audioTeam = [];
let audioStartSwitch = false;
const getAudioUrl = 'https://tsn.baidu.com/text2audio';
import {getBaiduToken} from '@/api/index'
let  appKey = 'QB7YcFpBQVer5u1giuVIGMCA',
 appSecret = 'ls4FgzpkeVbErUYwRX3gdUjYtWne4hly'

// function gettoken() { 
// 	return baidurequest({
//         url: '/oauth/2.0/token',
//         method: 'get',
//         params:{
// 			grant_type:'client_credentials',
// 			client_id:appKey,
// 			client_secret:appSecret
// 		},
//     }) 
// //  return baidurequest(`https://aip.baidubce.com/oauth/2.0/token?`)
// }
/**
 * 浏览器调用语音合成接口
 * 请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6
 * 强烈建议后端访问接口获取token返回给前端
 * client_id = API Key & client_secret = secret Key
 * 获取token接口: https://openapi.baidu.com/oauth/2.0/token?grant_type=client_credentials&client_id=uFYiXWMCiYvx68V4EVyCGeL8j4GAzXD5&client_secret=897Mm2qCj7bC1eHYVDxaWrO38FscTOHD
 */
let token = ''

function getBDVoicToken() {
	return new Promise((rs, rj) => {
		console.log('准备访问接口获取语音token')
		if (!token) {
			console.log('已有token',token)
			getBaiduToken().then(res=>{
				console.log('res:',res)
				token=res.data.access_token
				rs(token);
			})
		} else { 
			rs(token); 
		} 
	})
}

export default function openVoice(objs) { // 传入需转为语音的文本内容
	let lineUp = false;
	let returnAudio = false;
	if (typeof(objs) !== 'string') {
		if (objs && objs.lineUp === true) {
			lineUp = true;
		}
		if (objs && objs.returnAudio === true) {
			returnAudio = true;
		}
	}
	console.log("returnAudio",returnAudio);
	if (returnAudio) {
		return new Promise((resolve, reject) => {
			openVoiceFc(objs, returnAudio).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err)
			});
		})
	}


	if (lineUp = true) {
		audioTeam.push(objs);
	}
	console.log(audioTeam);
	if (!audioStartSwitch) {
		audioStartSwitch = true;
		openVoiceFc(objs);
	}
}

function openVoiceFc(objs, returnAudio) {
	console.log('准备获取语音tok');
	return new Promise((resolve, reject) => {
		getBDVoicToken().then(res => {
			console.log('获取语音tok接口成功');
			if (res) {
				let src = tts(objs, res, returnAudio);
				resolve(src);
			} else {
				console.log('获取语音tok接口为空');
				reject('获取语音tok接口为空');
			}
		}).catch(err => {
			console.log('获取语音tok接口失败');
			reject(err || '获取语音tok接口失败');
		})
	})
}

function tts(objs, tok, returnAudio) {
	if (typeof(objs) == 'string')
		objs = {
			voiceSet: {
				tex: objs
			}
		};
	const data = {
		tok,
		cuid: tok,
		ctp: 1,
		lan: 'zh',
		...objs.voiceSet
	}

	return btts(data, objs.audioSet);
}

function setAudioSet(options, audio) {
	if (options) {
		audio.volume = options.volume || 1;
		audio.startTime = options.startTime || 0;
		audio.loop = options.loop || false; 
		audio.obeyMuteSwitch = options.obeyMuteSwitch && typeof(options.obeyMuteSwitch) == 'boolean' ? options
			.obeyMuteSwitch :
			true; //支持微信小程序、百度小程序、头条小程序
	}
}

function btts(param, options) {
	// 序列化参数列表
	let fd = [];
	for (let k in param) {
		fd.push(k + '=' + encodeURIComponent(encodeURIComponent(param[k])));
	}
	// console.log(`播放路径：${getAudioUrl}?${fd.join('&')}`)
	return `${getAudioUrl}?${fd.join('&')}`

}
